import { useProcessAuth } from '../../hooks/fetch/auth/useProcessAuth'
import LabelText from './LabelText/LabelText'

const LoginBox = () => {
  const { loginUserId, setLoginUserId, password, setPassword, loginAuth } =
    useProcessAuth()

  const inputItems = [
    {
      type: 'text',
      labelId: 'userID',
      label: 'ユーザーID:',
      state: loginUserId,
      setState: setLoginUserId,
    },
    {
      type: 'password',
      labelId: 'password',
      label: 'パスワード:',
      state: password,
      setState: setPassword,
    },
  ]

   return (
    <div className="center">
      <div className="box w-contacts-box">
        <div className="stack">
          <h1>ログイン</h1>
          <form
            className="login-form-layout"
            onSubmit={(e) => {
              loginAuth(e)
            }}
          >
            <div className="stack">
              {inputItems.map((item, index) => (
                <LabelText
                  type={item.type}
                  key={index}
                  labelId={item.labelId}
                  label={item.label}
                  state={item.state}
                  setState={item.setState}
                />
              ))}
            </div>
            <button type="submit">ログイン</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginBox
